import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Drop-In Checkout allows you to use your own submit button for submitting forms. By default, the built-in submit button will be favored.`}</p>
    <p>{`Note that when disabling the built-in submit button and using your own custom submit button, it is required to implement the `}<a parentName="p" {...{
        "href": "/docs/sdk/web/2.x.x/primer-checkout/submit"
      }}>{`submit`}</a>{` function in order to notify Drop-In Checkout of form submissions.`}</p>
    <p>{`When using your own custom submit button, it's important to use the following callbacks to ensure that your submit button is in the correct state and in sync with the checkout as your customers interact with it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const options = {
    /* Other options ... */

    submitButton: {
        useBuiltInButton: false, // Default to true

        // Callback for receiving the submit button's visible state in the current scene
        onVisible(isVisible, context: { currentSceneId }) {
            // Show or hide your custom submit button
        },

        // Callback for receiving the submit button's disabled state in the current scene
        onDisable(isDisabled, context: { currentSceneId }) {
            // Disable or enable your custom submit button
        },

        // Callback for receiving the submit button's loading state in the current scene
        onLoading(isLoading, context: { currentSceneId }) {
            // Show your submit button in a loading state
        },

        // Callback for receiving the submit button's content in the current scene
        onContentChange(content, context: { currentSceneId }) {
            // Set your submit button's content with either the content provided or your own custom content
        },
    },
}
`}</code></pre>
    <Group summary='Properties' open mdxType="Group">
	<Item title='useBuiltInButton' subtitle='boolean' mdxType="Item">
		Set whether to use built-in submit button or to display your own custom button.
	</Item>
	<Item title='amountVisible' subtitle='boolean' mdxType="Item">
		Set whether the total order amount should be displayed in the submit button content.
	</Item>
    </Group>
    <Group summary='Callbacks' open mdxType="Group">
	<Item title='onVisible' subtitle='(isVisible: boolean, context: object) => void' mdxType="Item">
		Show or hide your custom submit button.
		<Group summary='context' open mdxType="Group">
			<Item title='currentSceneId' subtitle='string' mdxType="Item">
				An identifier for the current scene.
			</Item>
		</Group>
	</Item>
	<Item title='onDisable' subtitle='(isDisabled: boolean, context: object) => void' mdxType="Item">
		Disable or enable your custom submit button.
		<Group summary='context' open mdxType="Group">
			<Item title='currentSceneId' subtitle='string' mdxType="Item">
				An identifier for the current scene.
			</Item>
		</Group>
	</Item>
	<Item title='onLoading' subtitle='(isLoading: boolean, context: object) => void' mdxType="Item">
		Put your submit button in a loading state.
		<Group summary='context' open mdxType="Group">
			<Item title='currentSceneId' subtitle='string' mdxType="Item">
				An identifier for the current scene.
			</Item>
		</Group>
	</Item>
	<Item title='onContentChange' subtitle='(content: string, context: object) => void' mdxType="Item">
		Set your submit button's content with either the content provided or your own custom content.
		<Group summary='context' open mdxType="Group">
			<Item title='currentSceneId' subtitle='string' mdxType="Item">
				An identifier for the current scene.
			</Item>
		</Group>
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      